import { api } from './api';

const get = async () => {
  try {
    const result = await api.get(`/backoffice-funnel/schema`);
    return result.data;
  } catch (err) {
    console.error(err);
    return { funnels: [] };
  }
};

const create = async data => {
  try {
    const result = await api.post(`/backoffice-funnel/schema`, data);
    return result;
  } catch (err) {
    console.error(err);
    return {};
  }
};

const update = async (id, data) => {
  try {
    const result = await api.put(`/backoffice-funnel/schema/${id}`, data);
    return result;
  } catch (err) {
    console.error(err);
    return {};
  }
};

const deleteSchema = async id => {
  try {
    const result = await api.delete(`/backoffice-funnel/schema/${id}`);
    return result;
  } catch (err) {
    console.error(err);
    return {};
  }
};

export default {
  get,
  create,
  update,
  deleteSchema
};
